var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpSettingsWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33325H6.66667",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8887 6H12.154C10.964 6 10 6.89533 10 8C10 9.10467 10.9647 10 12.1533 10H13.8887C13.9447 10 13.972 10 13.9953 9.99867C14.3553 9.97667 14.642 9.71067 14.6653 9.37667C14.6667 9.35533 14.6667 9.32933 14.6667 9.278V6.722C14.6667 6.67067 14.6667 6.64467 14.6653 6.62333C14.6413 6.28933 14.3553 6.02333 13.9953 6.00133C13.9727 6 13.9447 6 13.8887 6Z",
    stroke: "#FFD600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9773 5.99996C13.9253 4.75196 13.7586 3.98663 13.2193 3.44796C12.4386 2.66663 11.1813 2.66663 8.66732 2.66663H6.66732C4.15332 2.66663 2.89598 2.66663 2.11532 3.44796C1.33465 4.22929 1.33398 5.48596 1.33398 7.99996C1.33398 10.514 1.33398 11.7713 2.11532 12.552C2.89665 13.3326 4.15332 13.3333 6.66732 13.3333H8.66732C11.1813 13.3333 12.4386 13.3333 13.2193 12.552C13.7586 12.0133 13.926 11.248 13.9773 9.99996",
    stroke: "#FFD600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 8H12",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpSettingsWalletIcon);
export default __webpack_public_path__ + "static/media/lp_settings_wallet_icon.d119c3512f372d01fa0984aecce5f9f0.svg";
export { ForwardRef as ReactComponent };